import API from './axios';
export class DownloadProductTableDataService {


    getProductsTableData(brandId:any): Promise<any> {
        return API.post(`api/index.php`, {
            action: 'getProductTableData', brandId:brandId,
            src: 'dashboard',
            retrievalmode: 'mysql'
        });
    }
}